<div *ngIf="(selectedLoyaltyAccount$ | async) as selectedAccount" class="form-group loyalty-accounts-grid">
  <ng-container *ngIf="selectedAccount">
    <div [ngSwitch]="selectedAccount.loyaltyProgram" class="strong">
      <ng-container *ngSwitchCase="'peterbilt'">Peterbilt</ng-container>
    </div>
    <div>{{ selectedAccount.loyaltyAccountIdentifier }}</div> 
  </ng-container>
</div>
